<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Mes demandes</span>
        <h3 class="page-title">Historique</h3>
      </div>
    </div>

    <div class="user-activity my-history-table mb-4">
      <!-- Activity Items -->
      <div class="my-history-text">
        <h4 class="my-history-text__heading">Mon Historique</h4>
      </div>
      <d-card-body class="responcive-pading">
        <spinner-dot v-if="!user.connected" />
        <history-days-off />
        <history-simple-absence />
        <history-recovery-request />
        <history-recovery-time />
        <HistroyMinibusRequest />
        <HistoryDemands />
        <HistoryDemandsRegie />
        <HistoryDemandsRetourRegie />
      </d-card-body>
    </div>
  </div>
</template>

<script>
import SpinnerDot from '../../components/layout/Loading/spinner-dot';
import HistoryDaysOff from '../../components/abscenceRequest/HistoryDaysOff';
import HistorySimpleAbsence from '../../components/abscenceRequest/HistorySimpleAbsence';
import HistoryRecoveryTime from '../../components/abscenceRequest/HistoryRecoveryTime';
import HistoryRecoveryRequest from '../../components/abscenceRequest/HistoryRecoveryRequest';
import HistroyMinibusRequest from '../../components/minibus/HistoryMinibusRequest.vue';
import HistoryDemands from '../../components/contract/HistoryDemands.vue';
import HistoryDemandsRegie from '../../components/regie/HistoryDemands.vue';
import HistoryDemandsRetourRegie from '../../components/retourRegie/HistoryDemands.vue';

export default {
  name: 'MyHistory',
  components: {
    HistoryRecoveryRequest,
    HistoryRecoveryTime,
    HistorySimpleAbsence,
    HistoryDaysOff,
    SpinnerDot,
    HistroyMinibusRequest,
    HistoryDemands,
    HistoryDemandsRegie,
    HistoryDemandsRetourRegie
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },
};
</script>

<style lang="scss">
.my-history-table {
  padding: 1.3rem 0;
  background-color: #fff;
  border-radius: 10px;
  .my-history-text {
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
    &__heading {
      font-weight: bold;
      padding-left: 2rem;
    }
  }
}
@media (max-width: 767px) {
  .responcive-pading {
    padding: 1rem 0 !important;
  }
}
</style>
